import { forwardRef } from 'react';

import { cn } from '@core-utils/cn';

import style from './Label.module.scss';

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
    { className, ...props },
    ref
) {
    return (
        <label className={cn(style.Label, className)} ref={ref} {...props} />
    );
});

export { Label };
